<ng-container *ngIf="isMapLoaded | async">
  <div class="map-container">
    <google-map
      height="80vh"
      width="100%"
      [zoom]="zoom"
      [center]="{ lat: mapState.location.center.lat, lng: mapState.location.center.lon }"
      [options]="mapOptions"
      (idle)="onIdle()"
      [attr.data-test-id]="'google-map'"
      [attr.data-zoom-level]="zoom"
      (mapClick)="onMapClick()"
      (boundsChanged)="onBoundsChange()"
    >
      <ng-container *ngIf="!flags.isNotCovidTab">
        <map-info-window #circleTooltip [options]="popupOptions" [attr.data-test-id]="'map-info-window-covid'">
          <ng-container *ngFor="let infoLabel of focusedCircle?.infoLabels; index as i">
            <span [attr.data-test-id]="'info-label-' + i">
              {{ infoLabel.title }}: <b>{{ infoLabel.value }}</b
              ><br />
            </span>
          </ng-container>
        </map-info-window>

        <map-circle
          *ngFor="let circle of markers; index as i; trackBy: trackByMarkerId"
          [center]="{ lat: circle.latitude, lng: circle.longitude }"
          [radius]="circle.radius"
          [options]="circleOptions"
          (circleMouseover)="onCircleMouseOver(circle)"
          [attr.data-test-id]="'map-info-window-covid-' + i"
        >
        </map-circle>
      </ng-container>

      <ng-container *ngIf="flags.isNotCovidTab">
        <map-info-window
          #markerPopup
          [options]="popupOptions"
          [attr.data-test-id]="'map-info-window'"
          (closeclick)="onMapClick()"
        >
          <app-marker-info [isLoggedIn]="flags.isLoggedIn" [isAdminSession]="isAdminSession"></app-marker-info>
        </map-info-window>

        <map-marker
          *ngFor="let marker of markers; index as i; trackBy: trackByMarkerId"
          [position]="{ lat: marker.latitude, lng: marker.longitude }"
          [label]="marker.label"
          [options]="markerOptions"
          [icon]="marker.icon"
          [attr.data-test-id]="'marker-' + i + '-' + marker.id"
          markerEventDirective
          (clicked)="onMarkerClick(marker)"
          (dblClicked)="handleMarkerClick(marker)"
          (mapMouseover)="onMarkerMouseOver(marker)"
        >
        </map-marker>
      </ng-container>

      <ng-container *ngIf="mapMarker">
        <map-marker
          [position]="{ lat: mapMarker.form_location.center.lat, lng: mapMarker.form_location.center.lon }"
          [options]="markerOptions"
          [attr.data-test-id]="'city-map-mark'"
        >
        </map-marker>
      </ng-container>
    </google-map>
  </div>
</ng-container>
